import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-content-end mb-3" }
const _hoisted_2 = { class: "p-input-icon-right ml-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon-search" }, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 6 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex -my-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_MultiSelect, {
        "model-value": _ctx.state.selectedColumns,
        options: _ctx.state.columns,
        "option-label": "header",
        placeholder: "Show attributes",
        style: {"width":"280px"},
        "onUpdate:modelValue": _ctx.onDisplayColumnUpdateSelection
      }, null, 8, ["model-value", "options", "onUpdate:modelValue"]),
      _createElementVNode("span", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_InputText, {
          modelValue: _ctx.state.keywords,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.keywords) = $event)),
          placeholder: _ctx.t('content.globalSearchInputPlaceholder'),
          style: {"width":"280px"},
          onKeyup: _ctx.onSearchKeywordResearchEquipmentClick
        }, null, 8, ["modelValue", "placeholder", "onKeyup"])
      ])
    ]),
    _createVNode(_component_DataTable, {
      filters: _ctx.filters,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event)),
      selection: _ctx.state.selectedDataRow,
      "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.selectedDataRow) = $event)),
      class: "p-datatable-sm",
      "column-resize-mode": "fit",
      "resizable-columns": true,
      "responsive-layout": "scroll",
      lazy: true,
      "total-records": _ctx.state.lazyParams.total,
      "selection-mode": "single",
      value: _ctx.state.researchEquipmentGroup,
      "filter-display": "menu",
      paginator: true,
      rows: _ctx.state.lazyParams.rows,
      "rows-per-page-options": [5, 10, 40],
      "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
      "current-page-report-template": `{currentPage} ${_ctx.t(
      'content.globalPagingInformation.ofTitle'
    )} {totalPages} ${_ctx.t('content.globalPagingInformation.pagesTitle')}`,
      "data-key": "id",
      loading: _ctx.state.dataLoading,
      onRowSelect: _ctx.onRowSelect,
      onPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPaginatorResearchEquipmentClick($event)))
    }, {
      paginatorend: _withCtx(() => []),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("content.noData")), 1)
      ]),
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t("content.globalLoadingText")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          "selection-mode": "single",
          style: {"width":"20px"},
          exportable: false
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.selectedColumns, (col, index) => {
          return (_openBlock(), _createBlock(_component_Column, {
            key: col.field + '_' + index,
            field: col.field,
            header: col.header,
            sortable: false,
            "filter-field": col.field,
            "show-filter-match-modes": false,
            style: {"max-width":"10%"}
          }, {
            body: _withCtx(({ data }) => [
              (col.field == 'link')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "router-link link",
                    to: { name: 'research-equipment-detail', params: { id: data.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("header.link")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (col.field == 'location')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(data[col.field].street) + ", " + _toDisplayString(data[col.field].postalCode) + " " + _toDisplayString(data[col.field].cityName), 1))
                  : (col.field == 'researchOrganization')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(data[col.field].number) + " " + _toDisplayString(data[col.field].name), 1))
                    : (col.field == 'researchGroup')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(data[col.field].number), 1))
                      : (col.field == 'equipmentFundingTypes')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(data.equipmentFundingTypes, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createElementVNode("p", null, _toDisplayString(item.number) + " " + _toDisplayString(item[_ctx.state.localProperty]) + " (" + _toDisplayString(item.type) + ") ", 1)
                            ]))
                          }), 128))
                        : (col.field == 'contactUsers')
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(data.contactUsers, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createElementVNode("p", null, _toDisplayString(item.firstname) + " " + _toDisplayString(item.lastname), 1)
                              ]))
                            }), 128))
                          : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(data[col.field]), 1))
            ]),
            _: 2
          }, 1032, ["field", "header", "filter-field"]))
        }), 128)),
        _createVNode(_component_Column, {
          header: "",
          "header-style": "text-align:center; width: 20px;"
        }, {
          body: _withCtx(({}) => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["filters", "selection", "total-records", "value", "rows", "current-page-report-template", "loading", "onRowSelect"])
  ], 64))
}